import { Stack } from "@/core/components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { Typography } from "@/core/components/ui/typography";
import { useEnv } from "@/core/env";
import { cn } from "@/core/utils/utils";
import { USER_ROLES } from "@/user/constants";
import { useGetMyUser } from "@/user/query";

const APP_ENV_TO_LABEL = {
  development: "Dev",
  staging: "Staging",
  demo: "Demo",
  production: "Prod",
} as const;

/*
 * Colors from figma
 * dev: blue 10, blue 80, blue 50
 * staging: yellow 10, yellow 80, yellow 50
 * demo: reuses the staging palette
 * prod: green 10, green 80, green 50
 */

const APP_ENV_TO_COLOR = {
  development: "bg-blue-10 text-blue-80 border-blue-50",
  staging: "bg-gold-10 text-gold-80 border-gold-50",
  demo: "bg-gold-10 text-gold-80 border-gold-50",
  production: "bg-green-10 text-green-80 border-green-50",
} as const;

const EnvPill = () => {
  const { appEnv } = useEnv();
  const { data: user } = useGetMyUser();

  // Only show for non-prod environments or admin users in prod
  if (appEnv === "production" && user?.role !== USER_ROLES.ADMIN) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          className={cn("rounded-full border px-3 py-1 text-xs font-medium", {
            [APP_ENV_TO_COLOR[appEnv]]: true,
          })}
        >
          {APP_ENV_TO_LABEL[appEnv]}
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <Stack gap="sm">
          <Typography variant="captionW1" textColor="primaryInverse">
            Current Environment: {APP_ENV_TO_LABEL[appEnv]}
          </Typography>
          <Typography variant="captionW1" textColor="primaryInverse">
            Environment pill is only visible to admins
          </Typography>
        </Stack>
      </TooltipContent>
    </Tooltip>
  );
};

export default EnvPill;
